import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

// Import assets
import PortalLogo from 'assets/icons/nexgentv_go.svg';

// Import components
import Nav from 'components/layout/nav/Nav';
import MobileNav from 'components/layout/mobile_nav/MobileNav';

// Import styles
import { HeaderStyled } from './styles';

// Import helpers
import { useOperators, useUserAgent } from 'components/utilities';
import { sendGTMEvent } from 'helpers/tracking';

// Import variables
import {
	GTM_TRACKING_EVENTS,
	GLOBAL_GTM_SEGMENTATION,
	FORM_GTM_ACTION
} from 'helpers/tracking';
import { MAIN_PATHS } from 'components/routes/app_routes/paths';

const { CLICK_HEADER_MENU } = GTM_TRACKING_EVENTS;
const { HOME } = MAIN_PATHS;

const Header = React.memo(() => {
	const { pathname } = useLocation();
	const { isLogged, isOperator } = useOperators();
	const { isMobile } = useUserAgent();
	const showNav = isOperator ? isLogged : true;

	const handleLogoClick = () => {
		sendGTMEvent({
			event: CLICK_HEADER_MENU,
			customEventData: {
				segmentation: GLOBAL_GTM_SEGMENTATION,
				action: FORM_GTM_ACTION,
				page_url: pathname,
				url: { url: HOME },
				text: 'Logo'
			}
		});
	};

	const renderNav = () => (isMobile ? <MobileNav /> : <Nav />);

	return (
		<HeaderStyled isMobile={isMobile}>
			<HeaderStyled.Wrapper isMobile={isMobile}>
				<HeaderStyled.Logo>
					<Link to={HOME} onClick={handleLogoClick}>
						<HeaderStyled.Image src={PortalLogo} alt="Logo" />
					</Link>
				</HeaderStyled.Logo>
				{showNav && renderNav()}
			</HeaderStyled.Wrapper>
		</HeaderStyled>
	);
});

Header.porpTypes = {
	isUserLoaded: PropTypes.bool.isRequired
};

const mapStateToProps = ({ auth: { isLogged } }) => ({
	isUserisLogged: isLogged
});

export default connect(mapStateToProps)(Header);
